import type { ReactNode } from 'react';

export interface NocKpiCardProps {
  label: string;
  value: ReactNode;
  hint?: ReactNode;
  icon?: ReactNode;
  /** Dentro del panel oscuro del hero (siempre superficie navy). */
  dark?: boolean;
}

/** Tarjeta de KPI del NOC (label + valor + pista). */
export function NocKpiCard({ label, value, hint, icon, dark = false }: NocKpiCardProps) {
  return (
    <div className={dark ? 'noc-kpi noc-kpi--dark' : 'noc-kpi'}>
      <div className="noc-kpi__head">
        {icon && (
          <span className="noc-kpi__icon" aria-hidden="true">
            {icon}
          </span>
        )}
        <span className="noc-kpi__label">{label}</span>
      </div>
      <div className="noc-kpi__value">{value}</div>
      {hint && <div className="noc-kpi__hint">{hint}</div>}
    </div>
  );
}
